<!-- src/views/SetToken.svelte -->
<script>
  import { onMount } from 'svelte';
  import { accessToken } from './store/auth-store';
  import { get } from 'svelte/store';
  import { navigateTo } from 'svelte-router-spa';

  onMount(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const dest  = params.get('dest') || '/';

    if (token) {
      // 1) 스토어 + localStorage에 저장
      accessToken.set(token);
    }

    // 2) 히스토리 뒤에 남기지 않고 최종 목적지로 이동
    navigateTo(dest);
	window.history.replaceState(null, '', dest);
  });
</script>

<main>
  <p>인증 처리 중입니다… 잠시만 기다려 주세요.</p>
</main>